module.exports = ".maps-tab-row .dropdown-menu {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popups/my-stuff/maps-section/maps-received/maps-received.component.less
// module id = ./src/app/components/popups/my-stuff/maps-section/maps-received/maps-received.component.less
// module chunks = main